import type { FaireProductEntity } from "../../entity_types/product";

export const p_jec7xsmpgv: FaireProductEntity = {
  token: "p_jec7xsmpgv",
  type: "product",
  name: "Mama Grip Socks",
  brandToken: "b_1fc44661",
  brandName: "Gumball Poodle",
  imageUrl: "https://cdn.faire.com/fastly/924595a04ddf57cfefaddc3c6ceed257def1197ca551f74e616770e376a21c47.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/f61ac439d23b8f07a0fa9129758b790f1ca69dd600d74aab615c744175062905.jpeg",
    "https://cdn.faire.com/fastly/184403900b41dada7697e49f47e630d9f4dc7ef236ae77fbe06e8de77f95a5d1.jpeg",
    "https://cdn.faire.com/fastly/3a28b577374e3fc9fd4721c050ab4332c3a2654d0225f15e19721eee2eb13ca7.jpeg",
    "https://cdn.faire.com/fastly/b28e293fdd633595573483033a4ec9b5d5e53ed6e09fd471ad87b8012783d84d.jpeg",
    "https://cdn.faire.com/fastly/998fb612f8e39fd5111efc3b5bbf2a18d91c3bebbca42cc035c79afcfdc9686f.jpeg",
    "https://cdn.faire.com/fastly/94425a1de3305fd94e8af0f638450c1e2911b8ba179e7ba520ccb4e00ff905a9.jpeg",
    "https://cdn.faire.com/fastly/097a9bde21d57eab51ae92691467151c7737080ae31e792ab7a47e25b8837a5a.jpeg",
    "https://cdn.faire.com/fastly/5ddbb88cf81a2c6e96825b0d63ba60d1d5ff21ce0331c7694652201582ac3b4c.jpeg"
  ],
  priceDollars: 9.6,
  description: "This \"Mama\" style is for anyone with an air of effortless authority and the stamina to back it up.\n\nFinally! Grip socks that do a better job and look good doing it. 🤩\n\n• Woven-in premium grip yarn that holds up use after use. No glued-on dots.\n• Knit into the heel and toe, not just the sole, for better stability.\n• Built for Pilates, barre, yoga, and every stretch in between.\n• Bold, funny, and unreasonably well made in the USA!\n\n#pilatessocks #gripsocks #grippysocks #barresocks #yogasocks #grippy #lagreesocks #pilates #barre #lagree #yoga #grip\n\nGumball Poodle is GPSR compliant! We will automatically be stickering all orders into the EU or Northern Ireland for GPSR compliance.\n\nIf you are in the UK but sell into the EU, we can provide you with the necessary stickers to put on products - be sure to tell us you need these when you place your order.",
  tags: [],
  msrpDollars: 20,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-12T05:36:26.599Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
